




























































import { Component, Mixins, Watch } from 'vue-property-decorator';
import Modal from './properties.modal.vue';
import TableMixin from '@/mixins/table.mixin';

@Component({
  components: { Modal },
})
export default class PropertiesShell extends Mixins(TableMixin) {
  // categories = [];

  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.NAME', name: 'name', sortable: true },
    {
      label: 'GENERAL.COMPANY',
      name: 'company',
      field: (row: any) => row.company?.name,
      sortable: true,
    },
    {
      label: 'GENERAL.CATEGORY',
      name: 'category',
      field: (row: any) => row.category?.name,
      sortable: true,
    },
    { label: 'GENERAL.EMAIL', name: 'email', sortable: true },
    {
      label: 'GENERAL.PHONE_NUMBER',
      name: 'phoneNumber',
      sortable: true,
      field: (row: any) => {
        const { countryCode, areaCode, number } = row.phoneNumber || {};
        if (countryCode) {
          return `${countryCode} (${areaCode}) ${number}`;
        }
      },
    },
    {
      label: 'GENERAL.DISTRICT_CITY',
      name: 'district',
      field: (row: any) => row.address?.district?.name,
      sortable: true,
    },
    {
      label: 'GENERAL.PROVINCE_STATE',
      name: 'province',
      field: (row: any) => row.address?.province?.name,
      sortable: true,
    },
    {
      label: 'GENERAL.COUNTRY',
      name: 'country',
      field: (row: any) => row.address?.country?.name,
      sortable: true,
    },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  filters = [
    { label: this.$i18n.t('GENERAL.NAME'), type: 'text', value: '', fieldName: 'name' },
    {
      label: this.$i18n.t('GENERAL.CATEGORY'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'category',
      namespace: 'definitions',
      action: 'findPropertyCategories',
    },
    /*
    {
      label: this.$i18n.t('GENERAL.COUNTRY'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: false,
      multiple: false,
      fieldName: 'country',
      namespace: 'geo',
      action: 'countries',
    },
    */
  ];

  @Watch('modal.open')
  onClose(value: boolean) {
    if (!value) this.onUpdateData();
  }

  /*
  async mounted() {
    const { data: categories } = await compass.do('definitions', 'findPropertyCategories', { lang: this.$i18n.locale });
    this.categories = (categories as any).map((c: any) => {
      return {
        value: c.code,
        label: c.name,
      };
    });
  }
  */
}
